// Sanitising is not optional: message bodies are attacker-controlled HTML.
import DOMPurify from "dompurify";

// Bodies render inside the dashboard SPA, so a link that navigated in place
// would throw the whole app away. Real links open in a new tab instead, with
// rel hardening so the opened page can't reach back through window.opener.
// The hook runs after attribute sanitising, so what it sets here sticks.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.nodeName !== "A") return;                       // HTML anchors only, not SVG <a>
  const href = node.getAttribute("href") || "";
  if (!/^https?:\/\//i.test(href)) return;                 // leave mailto:, tel:, cid:, #anchors alone
  node.setAttribute("target", "_blank");
  node.setAttribute("rel", "noopener noreferrer");
});

export const sanitize = (html) => DOMPurify.sanitize(html || "", {
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form"],
});

export default sanitize;
